import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import NfcsAccess from "../entities/stores/nfcAccess";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class NfcsAccessDB extends FirestorePipe {

  public static readonly colName = 'NfcsAccess'

  constructor(idEstab: string, idStore: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${NfcsAccessDB.colName}`);
  }

  public define(id: string, data: NfcsAccess): Promise<any> {
    return this._define(id, data);
  }
  public create(data: NfcsAccess): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: NfcsAccess): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<NfcsAccess[]> {
    return this._getAll<NfcsAccess>(...params);
  }
  public get(id: string): Promise<NfcsAccess> {
    return this._get(id);
  }
  public on(listener: (data: NfcsAccess[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default NfcsAccessDB;